// user actions
export const USER_CONTACTS = 'USER_CONTACTS';
export const CONTACT_LIST = 'CONTACT_LIST';

// group actions
export const LOAD_ADD_MEMBERS_CONTACTS = 'LOAD_ADD_MEMBERS_CONTACTS';
export const RESET_GROUP_STATE = 'RESET_GROUP_STATE';
